<div *ngIf="user && user.allowSearch">
  <div class="container-fluid">
    <h1 class="mt-5">Preferences</h1>
    <app-toasts-container aria-live="polite" aria-atomic="true"></app-toasts-container>
    <form [formGroup]="form" enctype="application/x-www-form-urlencoded" role="form" novalidate>
      <hr>
      <div class="row form-group">
        <div>
          <h2 class="text-base mt-0">Notification Settings</h2>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="sendSearchResultEmail"
              id="sendSearchResultEmail">
            <label class="form-check-label" for="sendSearchResultEmail">Send Search Results notifications to {{
              user.userLoginName }}</label>
          </div>
        </div>
      </div>
      <hr>
      <button type="button" class="btn btn-primary btn-min-width mb-4 me-4"
        (click)="onSave()">{{primaryButtonText}}</button>
    </form>
  </div>
</div>